/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBaseResponse as ModelsV3VehicleDtoVehicleBaseResponse } from '../../models/Models/v3/Vehicle/dto-vehicle-base-response';

export interface V3ApplicationsVehicleGet$Json$Params {
  StockNo: number;
  DealerCode?: string;
}

export function v3ApplicationsVehicleGet$Json(http: HttpClient, rootUrl: string, params: V3ApplicationsVehicleGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationsVehicleGet$Json.PATH, 'get');
  if (params) {
    rb.query('StockNo', params.StockNo, {});
    rb.query('DealerCode', params.DealerCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3VehicleDtoVehicleBaseResponse>;
    })
  );
}

v3ApplicationsVehicleGet$Json.PATH = '/v3/applications/vehicle';
